import { useQuery } from '@tanstack/react-query';
import { getProject } from 'services/projectService';
import keys from 'constants/queryKeys';

const useProject = ({ projectId, enabled = true }) => {
  const query = useQuery({
    queryKey: keys.Project(projectId),
    queryFn: () => getProject(projectId),
    enabled: enabled && !!projectId, // Only run query if enabled and projectId exists
  });

  return {
    ...query,
    ...query?.data?.data,
  };
};

export default useProject;
